import classnames from 'classnames';
import React, { ButtonHTMLAttributes, ReactNode } from 'react';

import { Icon } from '~/components/icon/Icon';
import { SvgIconNames } from '~/design-tokens/iconography/SvgIcons';

import styles from './ButtonLink.module.scss';

type IconPosition = 'left' | 'right';

export interface ButtonLinkProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: ReactNode;
  iconName?: SvgIconNames;
  iconPosition?: IconPosition;
  iconSize?: number;
  iconViewBox?: string;
}

export const ButtonLink = ({
  label,
  iconName,
  iconPosition = 'left',
  iconSize = 16,
  iconViewBox,
  className,
  ...rest
}: ButtonLinkProps) => {
  return (
    <button
      type="button"
      data-testid="button-link"
      className={classnames(styles.root, className)}
      {...rest}
    >
      <span
        className={classnames(styles.label, {
          [styles.labelReversed]: iconPosition === 'right',
        })}
        data-button-link-label
      >
        {iconName && (
          <Icon iconName={iconName} size={iconSize} viewBox={iconViewBox} />
        )}
        {label}
      </span>
    </button>
  );
};
